import React from 'react'
import {useSelector} from 'react-redux'
import styles from '../Viewer.module.scss'
import {useActionsColors} from '../../hooks/useCurrentTheme'
import {useComponentLocale} from '../../hooks/useComponentLocale'
import {
    selectDataNew,
    selectMatrixPreferences,
    selectReportMultiStack,
    selectReportOpenRaise,
    selectReportPosition,
    selectReportRake,
    selectView,
} from '../../Redux/selectors/selectors'
import {constants} from '../viewModeConstants'
import {Badge} from 'antd'
import {CardTextBlock} from '../../components/cards/CardTextBlock'
import classNames from 'classnames'
import {useTypeSelector} from "../../hooks/useTypeHooks";
import {getShortActionName} from "../graphics/UnionMultiReport/MultiStackMatrix/utils";

export function ColoredItem({actionName, raiseIndex, isAllIn, bg, text}) {
    const getColor = useActionsColors()
    const color = typeof raiseIndex === 'number' ? getColor(actionName, raiseIndex, isAllIn) : null
    return <Badge color={bg || color} text={text} style={{whiteSpace: 'nowrap'}}/>
}



const CellTooltip = ({
                         isTrainer,
                         values,
                         isStrategy,
                         cardString,
                         filter,
                         s1,
                         s2,
                         isMultiStack,
                         isPositions,
                         position,
                         stack,
                         isFromDetailMatrix = false,
                         isMatrix,
                         rake,
                         openRaise,
                         isRake,
                         isOpenRaise,
                         useAllCards = false
                     }) => {
    const {
        sizingsStructureData,
        activeQueryTraceIndex,
        trace,
        viewMode,
        calculateSizingsAllStacks,
        moveModeStrategy,
        isRequest,
        viewer_request_query,
    } = useSelector(selectView)

    const {common} = useTypeSelector(selectDataNew)
    const getColor = useActionsColors()
    const {isShowDetailedTooltip} = common
    const trainerSizings = useSelector((state) => state.trainer.sizings[0])
    const trainerTrace = useSelector((state) => state.trainer.tables[0].trace)
    const {multiStackViewMode, currentMatrixStack} = useSelector(selectReportMultiStack)
    const {
        positionData: {positionsSizings},
        currentPosition,
    } = useSelector(selectReportPosition)
    const {
        currentRake,
        rakeData: {rakeSizings},
    } = useSelector(selectReportRake)
    const {
        currentOpenRaise,
        openRaiseData: {openRaiseSizings},
    } = useSelector(selectReportOpenRaise)
    const {threshold, viewerSizings} = useSelector(selectMatrixPreferences)
    const isPostflop = !isRequest && viewer_request_query?.includes('_F.')

    let activeCard = activeQueryTraceIndex === -1 ? trace.findIndex((el) => el.is_active) : activeQueryTraceIndex
    let actions = sizingsStructureData?.[activeCard]

    if (isTrainer) {
        let activeCard = trainerTrace.findIndex((el) => el.is_active)

        actions = trainerSizings[activeCard]
    }

    if (isMultiStack && multiStackViewMode === 'many' && currentMatrixStack !== 0) {
        if (moveModeStrategy && stack) {
            actions = calculateSizingsAllStacks[stack]?.[activeCard]
        } else {
            actions = calculateSizingsAllStacks[currentMatrixStack]?.[activeCard]
        }
    }

    if (isPositions && multiStackViewMode === 'many' && currentPosition) {
        if (moveModeStrategy && position) {
            let index = trace.findLastIndex((item) => item.player === position)
            actions = positionsSizings[position]?.[index]
        } else {
            let index = trace.findLastIndex((item) => item.player === currentPosition)
            actions = positionsSizings[currentPosition]?.[index]
        }
    }

    if (isRake && multiStackViewMode === 'many' && currentRake) {
        if (moveModeStrategy && rake) {
            actions = rakeSizings[rake]?.[activeCard]
        } else {
            actions = rakeSizings[currentRake]?.[activeCard]
        }
    }

    if (isOpenRaise && multiStackViewMode === 'many' && currentOpenRaise) {
        if (moveModeStrategy && openRaise) {
            actions = openRaiseSizings[openRaise]?.[activeCard]
        } else {
            actions = openRaiseSizings[currentOpenRaise]?.[activeCard]
        }
    }

    const getLocale = useComponentLocale()
    const playedLocale = getLocale({component: 'viewer_table_tabs', section: 'played'})
    const EVLocale = getLocale({component: 'viewer_table_tabs', section: 'ev'})
    const handLocale = getLocale({component: 'common', section: 'hand'})
    const handsLocale = getLocale({component: 'common', section: 'hands'})
    const combosLocale = getLocale({component: 'common', section: 'combos'})
    const absLocale = getLocale({component: 'viewer_table_tabs', section: 'abs'})
    const equityLocale = getLocale({component: 'viewer_table_tabs', section: 'eq'})
    const eqrLocale = getLocale({component: 'viewer_table_tabs', section: 'eqr'})

    const vals = values.slice()
    const availableAction = vals.find((item) => item)

    // generate tooltip text
    const toolTipTableBody = []

    let eq = 0
    let ab = 0
    let eqr = 0
    let evAvg = 0
    let played = 0
    let cardCountAll = 0
    const cardArray = []

    for (let t = 0; t < vals.length; t++) {
        if (!vals[t]) {
            continue
        }

        for (let c = 0; c < vals[t].cards.c.length; c++) {
            const card = vals[t].cards.c[c]

            const holeSuit = card.s[1] + card.s[3]
            const checkCombo = filter.combos.includes(card.com)
            const checkDraw = filter.draws.includes(card.draw)
            const checkSuits = filter.suits.includes(holeSuit)

            if (s1 && s2) {
                if (card.s[1] === s1 && card.s[3] === s2 && checkCombo && checkDraw && checkSuits && card.abs > threshold) {
                    vals[t].cards.c[c].isValid = true
                    cardCountAll++
                } else {
                    vals[t].cards.c[c].isValid = false
                }
            } else if (checkCombo && checkDraw && checkSuits && card.abs > threshold) {
                vals[t].cards.c[c].isValid = true
                cardCountAll++
            } else {
                vals[t].cards.c[c].isValid = false
            }
        }
    }

    // fill cards arr for first action
    let validCountAll = 0
    let appendBlock

    if (vals.length > 0 && availableAction) {
        for (let c = 0; c < availableAction.cards.c.length; c++) {
            if (availableAction.cards.c[c].isValid) {
                validCountAll++
                if (validCountAll > 25) {
                    appendBlock = (
                        <span>
							+{validCountAll - 25} {handsLocale}
						</span>
                    )
                } else {
                    cardArray.push(
                        <div className={styles.tooltipCardContainer} key={availableAction.cards.c[c].s}>
                            <CardTextBlock cards={availableAction.cards.c[c].s} isSquare isFullWidth/>
                        </div>
                    )
                }
                ab += availableAction.cards.c[c].abs
            }
        }
    }

    cardArray.push(appendBlock)

    for (let t = 0; t < vals.length; t++) {
        if (!vals[t]) {
            continue
        }

        let ev = 0
        let pl = 0
        let actionAbs = 0

        for (let c = 0; c < vals[t].cards.c.length; c++) {
            const card = vals[t].cards.c[c]

            if (card.isValid) {
                ev += card.ev * card.abs
                pl += card.val * card.abs
                eq += card.eq
                eqr += card.eqr
                evAvg += card.ev
                played += card.abs

                actionAbs += card.abs
            }
        }

        let ev_disp = parseFloat(ev / actionAbs).toFixed(2)
        const evFontStyle =
            ev_disp > 0 ? styles.evPos : classNames(styles.evNeg, Number(ev_disp) === 0 ? styles.evZero : '')
        ev_disp = ev_disp > 0 ? `+${ev_disp}` : ev_disp

        /* check if pl / actionAbs !NaN/*/
        if (!isNaN(pl) && !isNaN(ev_disp)) {
            toolTipTableBody.push(
                <tr className={styles.cellTooltipBody}>
                    <td>
                        <ColoredItem
                            actionName={vals[t].action}
                            raiseIndex={vals[t].raiseIndex}
                            isAllIn={vals[t].isAllIn}
                            text={
                                (isMultiStack || isPositions || isRake || isOpenRaise) && !viewerSizings
                                    ? vals[t].action
                                    : actions?.[vals[t].action]
                            }
                        />
                    </td>

                    <td>
                        <div style={{position: 'relative'}}>
                            {parseFloat((pl / actionAbs) * 100).toFixed(2)}
                            <div className={styles.percentPlayedContainer}>
                                <div className={styles.percentPlayed}
                                     style={{width: `${(pl / actionAbs) * 100}%`}}></div>
                            </div>
                        </div>
                    </td>

                    <td className={evFontStyle}>{ev_disp}</td>
                </tr>
            )
        }


    }

    const getHandRows = () => {
        // get all actions
        const actionNames = [...new Set(vals.map(item => item.action))];
        const handData = {}

        // go throw hands and actions
        for (let i = 0; i < vals.length; i++) {
            const v_action = vals[i].action
            for (let j = 0; j < vals[i].cards.c.length; j++) {
                const hKey = vals[i].cards.c[j].s
                if (!(hKey in handData)) {
                    handData[hKey] = {
                        hand: vals[i].cards.c[j].s,
                        actions: new Array(actionNames.length),
                        ev: vals[i].cards.c[j].ev,
                        eq: vals[i].cards.c[j].eq,
                        eqr: vals[i].cards.c[j].eqr,
                    }
                    handData[hKey]['actions'][actionNames.indexOf(v_action)] = vals[i].cards.c[j].val
                } else {
                    handData[vals[i].cards.c[j].s]['actions'][actionNames.indexOf(v_action)] = vals[i].cards.c[j].val
                }
            }
        }

        const res = []
        for (const h in handData) {

            let ev_disp = parseFloat(handData[h].ev).toFixed(2)
            const evFontStyle =
                ev_disp > 0 ? styles.evPos : classNames(styles.evNeg, Number(ev_disp) === 0 ? styles.evZero : '')
            ev_disp = ev_disp > 0 ? `+${ev_disp}` : ev_disp

            res.push(
                <tr>
                    <td style={{width: `${100 / (vals.length + 4)}%`}}>
                        <div className={styles.tooltipCardContainer} key={handData[h].hand}>
                            <CardTextBlock cards={handData[h].hand} isSquare isFullWidth/>
                        </div>
                    </td>
                    {handData[h].actions.map(a => {
                        return (
                            <td style={{width: `${100 / (vals.length + 4)}%`, textAlign: "right"}} key={h.hand + '_' + a}>
                                <div style={{position: 'relative', right: 0}}>
                                    {(a * 100).toFixed(2)}
                                    <div className={styles.percentPlayedContainer}>
                                        <div className={styles.percentPlayed}
                                             style={{width: `${a * 100}%`, position: 'absolute', right: 0}}>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        )
                    })}
                    <td style={{textAlign: "right", width: `${100 / (vals.length + 4)}%`}} className={evFontStyle}>{ev_disp}</td>
                    <td style={{textAlign: "right", width: `${100 / (vals.length + 4)}%`}}>{handData[h].eq?.toFixed(2)}</td>
                    <td style={{textAlign: "right", width: `${100 / (vals.length + 4)}%`}}>{handData[h].eqr ? handData[h].eqr.toFixed(2) : '-'}</td>
                </tr>
            )
        }

        return res
    }


    const getTableHeaderCommon = () => {
        return (
            <thead className={styles.cellTooltipHeader}>
            <tr>
                <td>Actions</td>
                <td>{playedLocale}, %</td>
                <td className={styles.evZero}>{EVLocale}</td>
            </tr>
            </thead>
        )
    }

    const getTableHeaderDetailed = () => {

        return (
            <thead className={styles.cellTooltipHeader}>
            <tr>
                <td>Hand</td>
                {
                    vals.map((v) => {

                        // get action text
                        let aText = viewerSizings ? v.action : actions?.[v.action]

                        if (aText) {
                            aText = aText.replace(' to ', ' ')
                            const aTextArr = aText.split(' ')
                            aText = aTextArr.length > 1 ? aTextArr[0][0] + ' ' + aTextArr[1] : aTextArr[0][0]
                        }
                        else {
                            aText = ''
                        }

                        return (
                            <td style={{textAlign: 'right'}} key={'hdr_' + v.action}>
                                <ColoredItem
                                    actionName={v.action}
                                    raiseIndex={v.raiseIndex}
                                    isAllIn={v.isAllIn}
                                    text={aText}
                                />
                            </td>
                        )
                    })
                }
                <td style={{textAlign: 'right'}}>{EVLocale}</td>
                <td style={{textAlign: 'right'}}>Eq</td>
                <td style={{textAlign: 'right'}}>EqR</td>
            </tr>
            </thead>
        )
    }


    const renderMainTable = () => {
        return (
            <table>
                <thead className={styles.cellTooltipHeader}>
                <tr>
                    <td>{handLocale}</td>
                    {cardCountAll > 0 && (
                        <>
                            {viewMode === constants.GRAPHICS && (
                                <>
                                    {isPositions && <td className={styles.cellTooltipHeader}>Position</td>}
                                    {isMultiStack && <td className={styles.cellTooltipHeader}>Stack</td>}
                                    {isRake && <td className={styles.cellTooltipHeader}>Rake</td>}
                                    {isOpenRaise && <td className={styles.cellTooltipHeader}>Open raise</td>}
                                </>
                            )}
                            <td>{combosLocale}</td>
                            <td>{absLocale}</td>
                            <td>{equityLocale}, %</td>
                            <td>{eqrLocale}, %</td>
                        </>
                    )}
                </tr>
                </thead>

                <tbody>
                <tr>
                    <td>
                        {isFromDetailMatrix ? (
                            <div className={styles.tooltipCardContainer} key={cardString}>
                                <CardTextBlock cards={cardString} isSquare isFullWidth/>
                            </div>
                        ) : (
                            cardString
                        )}
                    </td>
                    {cardCountAll > 0 && (
                        <>
                            {viewMode === constants.GRAPHICS && (
                                <>
                                    {isPositions && <div>{availableAction.position}</div>}
                                    {isMultiStack && <div>{availableAction.stack}</div>}
                                    {isRake && <div>{availableAction.rake}</div>}
                                    {isOpenRaise && <div>{availableAction.openRaise}</div>}
                                </>
                            )}
                            <td>{parseFloat(ab).toFixed(2)}</td>
                            <td>{parseFloat(played / cardCountAll).toFixed(2)}</td>
                            <td>{parseFloat((eq / cardCountAll / 100) * 100).toFixed(2)}</td>
                            <td>{isPostflop ? parseFloat((eqr / cardCountAll / 100) * 100).toFixed(2) : '-'}</td>
                        </>
                    )}
                </tr>
                </tbody>
            </table>
        )
    }

    return (
        <div className={styles.tooltipContent}>
            {renderMainTable()}

            {cardCountAll > 0 ? (
                <>
                    {isStrategy && (
                        <>
                            <table>
                                {isShowDetailedTooltip ?
                                    getTableHeaderDetailed() : getTableHeaderCommon()}
                                <tbody>
                                {
                                    isShowDetailedTooltip ? getHandRows() : toolTipTableBody
                                }
                                </tbody>
                            </table>
                        </>
                    )}
                    {!isFromDetailMatrix && !isShowDetailedTooltip &&<div className={styles.tooltipCardsContainer}>{cardArray}</div>}
                </>
            ) : (
                <h3>No hole cards match filters</h3>
            )}
        </div>
    )
}

export default CellTooltip
